import { getRiderDeviceInstanceId } from "./riderDevice";

// Components outside the run page also need to know whether this device controls
// a run - RequiredTrackingProvider mounts a tracking card app-wide, and it cannot
// read the run page's state. sessionStorage has no change event of its own for
// same-tab writes, so claiming and releasing announce themselves here.
const AUTHORITY_CHANGED = 'apparify:rider:execution-authority-changed';

function announce() {
  window.dispatchEvent(new Event(AUTHORITY_CHANGED));
}

export function subscribeRiderExecutionAuthority(listener) {
  window.addEventListener(AUTHORITY_CHANGED, listener);
  return () => window.removeEventListener(AUTHORITY_CHANGED, listener);
}

// A primitive, so useSyncExternalStore can compare snapshots by value. Returns ''
// when this device holds nothing for the run.
export function riderExecutionAuthoritySnapshot(businessId, runId) {
  const authority = readRiderExecutionAuthority(businessId, runId);
  return authority ? `${authority.authorityId}:${authority.authorityVersion}` : '';
}

function key(businessId, runId) {
  return `apparify:rider:execution-authority:${Number(businessId)}:${Number(runId)}`;
}

export function saveRiderExecutionAuthority(businessId, runId, authority) {
  sessionStorage.setItem(key(businessId, runId), JSON.stringify({
    token: authority.executionToken,
    authorityVersion: authority.authorityVersion,
    authorityId: authority.id,
  }));
  announce();
}

export function readRiderExecutionAuthority(businessId, runId) {
  try {
    const value = JSON.parse(sessionStorage.getItem(key(businessId, runId)) || 'null');
    if (!value?.token || !Number.isInteger(Number(value.authorityVersion))) return null;
    return value;
  } catch {
    return null;
  }
}

export function clearRiderExecutionAuthority(businessId, runId) {
  sessionStorage.removeItem(key(businessId, runId));
  announce();
}

export function riderExecutionHeaders(businessId, runId) {
  const authority = readRiderExecutionAuthority(businessId, runId);
  if (!authority) return null;
  return {
    'X-Delivery-Execution-Token': authority.token,
    'X-Delivery-Execution-Version': String(authority.authorityVersion),
    'X-Delivery-Device-Id': getRiderDeviceInstanceId(),
  };
}
